module.exports = __webpack_public_path__ + "static/media/expert (8).cfd16aa4.png";